import { createFileRoute } from "@tanstack/react-router";

import TodosFastlane from "@/features/todos/todos-fastlane";

export const Route = createFileRoute(
  "/_authenticated/$company/buchhaltung/ausgang/fastlane",
)({
  component: ReceivableFastlanePage,
  staticData: {
    breadcrumb: ["todos.receivable.title"],
  },
});

function ReceivableFastlanePage() {
  return <TodosFastlane type="receivable" />;
}
